import 'src/styles/ui/action-panel.css';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import ActionError from 'src/components/action-error';

import Button from './Button';

/**
 * Shared error display component for action panels
 * Shows error icon, message, and action button
 */
const ErrorDisplay = ({
  title = 'Something Went Wrong',
  message,
  buttonText = 'Go Back',
  iconForButtonShown = true,
  onButtonClick,
}) => {
  return (
    <div className='action-panel-error-container'>
      <ActionError />
      <div className='action-panel-error-content'>
        <h4 className='action-panel-error-title'>{title}</h4>
        <p className='action-panel-error-message'>{message}</p>
      </div>
      {onButtonClick && (
        <Button
          variant='info'
          icon={iconForButtonShown && <FontAwesomeIcon icon={faArrowLeft} />}
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

ErrorDisplay.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  iconForButtonShown: PropTypes.bool,
};

export default ErrorDisplay;
